import { Component, OnInit, Inject, ChangeDetectorRef } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Item } from "./item";
import { UserService } from "../../../services/user.service";
import { LocationService } from "../../../services/location.service";
import { TicketsService } from "../../../services/tickets.service";
import { ProcessingpService } from "../../../services/processing.service";
import { Methods } from "../../methods";
import { PurchaseService } from "../../../services/purchase.service";
import { WeightItemService } from "../../../services/weightitem.service";
import { ChatLogService } from "../../../services/chatlog.service";
import { ChatLog } from "../../../models/chatLog";
import { SecurazeService } from "../../../services/securaze.service";
import { Containersvice } from "../../../services/container.service";
import { GuiGuard } from "../../guard/base-gui-guard";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";
import { Router } from "@angular/router";
import { DinamicData, Cell } from "../../../models/dinamic-data";
import { PrincipalinventoryService } from "../../../services/principalinventory.service";
import swal from "sweetalert2";
import { Icon } from "../../../models/card-icon";

/*ATTRIBUTE MULTIPLE ITEMS*/
import { attributeMultipleItemsComponent } from '../../../shared/components/attribute-multiple-items/attribute-multiple-items.component';
import { ContainerphotosComponent } from "../../../shared/components/containerphotos/containerphotos.component";

declare const $: any;

@Component({
  selector: "app-crud",
  templateUrl: "./containerCrud.component.html",
  styleUrls: ["./containerCrud.component.css"],
  providers: [
    LocationService,
    PurchaseService,
    ChatLogService,
    GuiGuard,
    ProcessingpService,
    SecurazeService,
  ],
})
export class ContainerCrudComponent implements OnInit {
  public mtds: Methods = new Methods();

  public edit = true;
  public loading = false;
  public loading2 = false;
  public saving = false;
  public saving2 = false;
  public loadingLocations = true;
  public locationsList: any[] = [];
  public item: Item = new Item();
  public poOptions: any[] = [];

  public containers;

  public apikey;
  public identity;
  public token;
  public whs_id = null;
  public internal_id = null;

  public po = "";

  public chats: Array<ChatLog>;
  public newchatmsg;
  public jsonChatLog;

  public idChat;
  public itemChat;
  public typeChat;

  public filtros = [];

  myWebSocket: WebSocketSubject<any> = webSocket(
    "wss://www.greenteksolutions.com/myws"
  );
  public numberNotifications;
  public notificationsData;

  iconTitleContainer: Icon = {
    icon: "chrome_reader_mode",
    title: "",
  };

  public typesofequipment = [
    "AIO",
    "eBay",
    "HDD/SSD",
    "Laptops",
    "LCDs",
    "LCDs - Grade A - W/O Stand",
    "LCDs - Grade A - W/Stand",
    "LCDs - Grade B - W/O Stand",
    "LCDs - Grade B - W/Stand",
    "LCDs - Grade C - W/O Stand",
    "LCDs - Grade C - W/Stand",
    "LCDs - Pending Testing",
    "Misc",
    "Networking",
    "Office Supplies",
    "PCs",
    "POS",
    "Printers",
    "Scrap",
    "Servers",
    "Telecom",
    "Warehouse Supplies",
    "Workstations",
    "Custom",
  ];

  public inventories: DinamicData = new DinamicData([
    "check",
    "Id",
    "Mfgr",
    "Item",
    "Serial#",
    "Condition",
    "Status",
    "Actions",
  ]);

  public savingItem = false;

  public enableAsVirtual = false;
  public unlockNameVirtual = true;
  public gettingContainers = false;
  public containerList: Array<any> = [];
  public virtualContainerID = 0;
  public showContainerList = false;
  public containerinventory = "";
  public itemID;
  public itemsID: Array<any> = [];
  public itemsAdd: Array<any> = [];
  public containerAlreadyExist = false;
  public confirmMove = false;
  public saveConfirmMove = false;

  /*ITEMS EN LA TABLA*/
  public bulk: Array<number> = [];
  public massiveBulk: Array<number> = [];

  public bulk_cant = 0;
  public massive = false;

  /*NUEVO DISEÑO CONTAINER*/
  public options = [];
  public tab = 1;

  public stages = [
    {value: 1, viewValue: '1st'},
    {value: 0, viewValue: '2nd'},
    {value: 3, viewValue: '3rd'},
    {value: 4, viewValue: '4th'}
  ];

  public damages = [
    {value: 'Yes', viewValue: 'Yes'},
    {value: 'No', viewValue: 'No'}
  ];

  public total_chats: any = 0;

  public is_warehouse: boolean = false;

  public lockStage: boolean = true;

  constructor(
    public gui: GuiGuard,
    private _processingpService: ProcessingpService,
    private _serviceWeigth: WeightItemService,
    private _userService: UserService,
    private _locationService: LocationService,
    private _purchaseService: PurchaseService,
    private _ticketsService: TicketsService,
    private _chatLogService: ChatLogService,
    private _containerService: Containersvice,
    public dialogRef: MatDialogRef<ContainerCrudComponent>,
    public dialog: MatDialog,
    private _inventoryService: PrincipalinventoryService,
    private _securazeService: SecurazeService,
    private _router: Router,
    private ref: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.options = [
      {
        colName: "Details",
        visibility: true,
        tab: 1,
        icon: 'info_outline'
      },
      {
        colName: "Add Item",
        visibility: true,
        tab: 2,
        icon: 'add'
      },
      {
        colName: "View Items",
        visibility: false,
        tab: 3,
        icon: 'remove_red_eye'
      },
      {
        colName: "Notes",
        visibility: true,
        tab: 4,
        icon: 'notes'
      },
    ];

    console.log(data);

    if (data.data !== "holis") {
      if (data.data.enableAsAVirtualContainer !== 1) this.po = data.data.ponumber;

      const nameInternal =
        data.data.internalLocationId !== null
          ? data.data.internalLocationName +
            ": " +
            data.data.internalLocationRow +
            "-" +
            data.data.internalLocationBay +
            "-" +
            data.data.internalLocationLevel +
            "-" +
            data.data.internalLocationSection
          : null;
      let idinternal = null;

      if (data.data.internalLocationId) {
        idinternal = data.data.internalLocationId;
      }

      if (data.data.enableAsAVirtualContainer !== 1) {
        this.item = new Item(
          data.data.id,
          data.data.poid,
          data.data.item,
          data.data.weight,
          data.data.totalNetWeight,
          data.data.damages,
          data.data.comments,
          idinternal,
          data.data.isPi,
          nameInternal,
          data.typeEquipment,
          data.data.pending,
          data.data.enableAsAVirtualContainer,
          data.data.nameVirtualContainer,
          data.data.internalLocationId !== null
            ? data.data.internalLocationlinkTo
            : null
        );
      }

      if (data.data.enableAsAVirtualContainer === 1) {
        this.enableAsVirtual = true;
        this.unlockNameVirtual = false;

        this.item = new Item(
          data.data.id,
          null,
          "",
          0,
          0,
          "",
          data.data.comments,
          idinternal,
          0,
          nameInternal,
          "",
          0,
          data.data.enableAsAVirtualContainer,
          data.data.nameVirtualContainer,
          data.data.internalLocationlinkTo !== null
            ? data.data.internalLocationlinkTo
            : null
        );

        console.log(this.item);
      }
      this.whs_id = data.data.locationid

      this.is_warehouse = true;

      this.getInventories(this.data.id);
    } else {
      if (data.virtual === 1) this.enableAsVirtual = true;

      this.loadingLocations = false;
      this.item = new Item();
      this.loading = true;
      this._ticketsService.getPOs().subscribe((r) => {
        //console.log(r);
        this.poOptions = r.data;
        this.loading = false;
      });
    }
    this.refreshVirtualCreationTabs();
    this.identity = this._userService.getIdentity();
    this.apikey = this.identity.apiCompany;
    this.token = this._userService.getToken();

    this._serviceWeigth
      .getItem(this.token, data.data.id)
      .subscribe((response) => {
        console.log(response);

        if(response.status === 'success'){

          this.item.typeEquipment = response.data.typeEquipment;
          this.item.customType = response.data.customType || '';
          if(this.item.po_id == null){
            this.item.po_id = response.data.po.id
            this.po = response.data.po.po
          }
          if(this.item.internallocation_id == null){
            this.item.internallocation_id = response.data.internalLocation.id;
            this.item.linkTo = response.data.internalLocation.linkTo;
            this.whs_id = response.data.internalLocation.location.id;
          }

        }
        if (this.item !== null) {
          this.getLocations();
        }
        console.log(this.item);
      });

    if (this.token) {
      console.log("entramos crud");
      this._userService.getUser(this.token, this.identity.sub).subscribe(
        (response) => {
          console.log(response);
          if (response.status === "success") {

            if(!this.is_warehouse && response.data.location && response.data.location.id){
              //this.whs_id = response.data.location.id;
            } 

            if (response.data.internalLocation !== null) {
              this.internal_id = response.data.internalLocation.id;
              if (this.item.id == null) {
                this.item.internallocation_id = this.internal_id;
                this.item.nameInternal = "";
                this.item.linkTo = response.data.internalLocation.linkTo;
              }
            }

            if (this.item !== null) {
              this.getLocations();
            }
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    }
    this.getChat();
    this.getContainers();
    this.virtualContainerID = this.item.id;
  }

  onEnter(event: KeyboardEvent): void {
    if (event.key === 'Enter') {

      //Almacenar el contenido del textarea en un array, separando por saltos de línea
      const linesArray = this.nuevo.value.split('\n');
      
      // Obtener el último elemento del array
      const lastLine = linesArray[linesArray.length - 1];

      // Verificar si el último elemento ya existe en el array
      const isLastLineRepeated = linesArray.indexOf(lastLine) !== linesArray.length - 1;

      console.log('Array of lines:', linesArray);
      console.log('Last line:', lastLine);
      console.log('Is last line repeated:', isLastLineRepeated);

      if(isLastLineRepeated){

        alert(lastLine + " is repeated!");

        // Se eliminar último elemento agregado
        linesArray.splice(linesArray.length - 1, 1);

        // Unir los elementos del array de nuevo en una cadena
        this.nuevo.value = linesArray.join('\n');

      }
      
    }
  }

  public view_details = false;

  changeTab(tab, disabled) {

    if(disabled === null && tab === 2) return;
    if(this.view_details === true && tab === 1) return;

    this.tab = tab;
  }

  total_chats_func(e) {
    this.total_chats = e;
  }

  //Método para filtrar elementos basados en la propiedad visibility
  getVisibleOptions() {
    return this.options.filter(option => option.visibility);
  }

  // While creating a brand-new virtual container, only Details should be visible.
  // Once it has been saved (item.id is set), Add Item and Notes unlock.
  refreshVirtualCreationTabs() {
    const hideExtraTabs = this.enableAsVirtual && this.item.id === null;
    const addItemTab = this.options.find(option => option.colName === 'Add Item');
    const notesTab = this.options.find(option => option.colName === 'Notes');
    if (addItemTab) addItemTab.visibility = !hideExtraTabs;
    if (notesTab) notesTab.visibility = !hideExtraTabs;
  }

  receive_item_id(valor){
    //recibimos valor id del CID creado desde el app-comment
    console.log("receive_item_id => ", valor);
    this.item.id = valor;
  }

  changeLocation(location) {
    console.log(location);
    (this.item.internallocation_id = location.id),
      (this.item.nameInternal = location.name);
    if (this.item.id === null) {
      this.item.linkTo = location.linkTo;
    }
  }

  onValueChange(value: any) {
    this.item.internallocation_id = value;
  }

  reportWithAttributes(){

    let bulk;

    if(this.bulk.length > 0)
      bulk = this.bulk;
    else
      bulk = this.massiveBulk;

    const json = {
      apikey: this.apikey,
      data: bulk
    }

    this._inventoryService.reportWithAttributes(json).subscribe(
        response => {
          //console.log(response);
          if (response._body) {
            let body = JSON.parse(response._body);
            this.mtds.notifyError(body.error);
          } else {
            const url = response.headers.get('Content-Disposition').split('=');
            window.open(url[1]);
          }
        }, error => {
          console.log(error);
        }
      );
  }

  reportWithAttributesExtreme(){

    let bulk;

    if(this.bulk.length > 0)
      bulk = this.bulk;
    else
      bulk = this.massiveBulk;

    const json = {
      apikey: this.apikey,
      data: bulk
    }

    this._inventoryService.reportWithAttributesExtreme(json).subscribe(
        response => {
          //console.log(response);
          if (response._body) {
            let body = JSON.parse(response._body);
            this.mtds.notifyError(body.error);
          } else {
            const url = response.headers.get('Content-Disposition').split('=');
            window.open(url[1]);
          }
        }, error => {
          console.log(error);
        }
      );
  }

  attributeMultipleItems(){

    let bulk;

    if(this.bulk.length > 0)
      bulk = this.bulk;
    else
      bulk = this.massiveBulk;

    let dialogRef = this.dialog.open(attributeMultipleItemsComponent, {
        width: "90%",
        data: bulk,
        disableClose: true,
        autoFocus: false,
        maxHeight: '90vh' //you can adjust the value as per your view
      });

      dialogRef.afterClosed().subscribe((result) => {
        //this.getData();
      });
  }

  getContainers() {
    this.gettingContainers = true;
    this._securazeService.getContainers(this.token).subscribe(
      (response) => {
        console.log(response.data);
        response.data.forEach(
          function (element) {
            //  console.log(element);
            this.containerList.push({
              id: element.id,
              name: element.nameVirtualContainer,
            });
          }.bind(this)
        );
        // this.mgfrList = response.data.map( data => {
        //   return {id: data.id, name: data.name}
        // });
        console.log(this.containerList);

        this.containerList.sort((a, b) => {
          const n1 = a.name.toLowerCase();
          const n2 = b.name.toLowerCase();

          if (n1 < n2) {
            return -1;
          }
          if (n1 > n2) {
            return 1;
          }
          return 0;
        });

        //console.log(this.containerList);

        this.gettingContainers = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.gettingContainers = false;
      }
    );
  }

  changeBulk(evento){
    console.log("evento => ", evento);
    if(evento && evento.cleanall){
      this.bulk =[];
    }
  }

  cleanValues() {
    //this.containerAlreadyExist = false;
    this.itemID = 0;
    this.nuevo.value_two = '';
    this.confirmMove = false;
    this.itemsID = [];
    this.itemsAdd = [];
    this.nuevo.value = '';
  }
  ifDataPo(Ponumber){
    this._processingpService.getstage(this.token, Ponumber).subscribe(
      (r) => {
        console.log(r);
        this.item.is_pi = r.data;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }
  ngOnInit() {
    if(this.data.poNumber != undefined){
      this.item.po_id =  this.data.poId;
      this.po = this.data.poNumber;
      this.tab = 1;
      this.ifDataPo(this.data.poNumber);
      console.log(this.tab)
    }
    $("#createModal").on("hidden.bs.modal", () => {
      this.nuevo = {
        type: "iqid",
        value: "",
        value_two: "",
        change: 0,
      };
    });
    if (this.item.id) {
      !this.enableAsVirtual
        ? (this.iconTitleContainer.title = `Show Container  #${this.item.id} - PO: ${this.po}`)
        : "Show virtual container";
    } else {
      this.po
        ? (this.iconTitleContainer.title = `Create New Container - PO ${this.po}`)
        : (this.iconTitleContainer.title = `Create New Container`);
    }

    this._containerService.showAll().subscribe((response) => {
      if (response.code === 400 && response.msg === "Authorization not valid") {
        this.mtds.notifyError("Your session has expired");
        localStorage.clear();
        this._router.navigate(["/pages/lock"]);
      } else if (response.code === 200) {
        this.containers = response.data;
      }
    });
  }

  unlockNameVirtualFunction(param) {
    this.unlockNameVirtual = !this.unlockNameVirtual;

    if (param === 1) {
      if (this.enableAsVirtual) {
        this.item.enableAsAVirtualContainer = 1;

        this._ticketsService.editVirtual(this.item.id, this.item).subscribe(
          (r) => {
            if (r.status === "success") {
            } else {
              this.mtds.notifyError(r.msg, r.code);
            }
          },
          (error) => {
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
      }
    }
  }

  checkVirtual(event) {
    //console.log(event);
    //console.log(event.source.id);

    if (event.checked) this.enableAsVirtual = true;
    else this.enableAsVirtual = false;
  }

  public nuevo = {
    type: "iqid",
    value: "",
    value_two: "",
    change: 0,
  };

  saveItem() {
    //this.containerAlreadyExist = false;

    let json = {
      type:  this.nuevo.type,
      value: this.nuevo.value,
      items: this.itemsID
    }

    console.log(json);

    this.savingItem = true;
    swal.fire({
          
      title: "We are adding items to the container. This process may take some time. Please check back in about 2-3 Mins",
      text: "",
      buttonsStyling: false,
   
      customClass:{
        confirmButton: 'btn btn-success'
      },
      icon: "success",
    });
    this._inventoryService
      .createForContainer(this.item.id, json)
      .subscribe(
        (r) => {
          console.log(r);
          /*if (r.code === 200 && r.itemID.length === 0) {
            swal.fire({
     
              title: "Item(s) have been added successfully",
              text: "",
              buttonsStyling: false,
            
               customClass:{
                confirmButton: 'btn btn-success'
              },
              icon: "success"
            });
            $("#createModal").modal("hide");
            this.getInventories();
          } else */
          if (r.code === 200) {
            //this.containerAlreadyExist = true;

            this.itemsID = [];
            this.itemsID = r.itemID;

            if(this.itemsAdd.length === 0 && r.itemsAdd)
              this.itemsAdd = r.itemsAdd;
            else if (this.itemsAdd.length !== 0 && r.itemsAdd){
              this.itemsAdd = this.itemsAdd.concat(r.itemsAdd);
              this.ref.detectChanges();
            }

            this.nuevo.value = r.itemsCheck;
            this.getInventories(this.item.id, true, true);
            //this.checkItemsNotFound();
          } else {
            this.mtds.notifyError(r.msg);
          }
          this.savingItem = false;
        },
        (error) => {
          console.log(error);
          /*swal.fire({
          
            title: "We are adding items to the container. This process may take some time. Please check back in about 2-3 Mins",
            text: "",
            buttonsStyling: false,
         
            customClass:{
              confirmButton: 'btn btn-success'
            },
            icon: "success",
          });*/
          this.savingItem = false;
        }
      );
  }

  public loadingInventories = false;

  public campoBusqueda = "";
  public paginaActual = 1;
  public itemsPorPagina = "10";
  public totalItems = 0;
  public totalPaginas = 1;

  getInventories(e = null, newfilter = true, additems = false) {
    this.loadingInventories = true;
    console.log(this.data.data);
    this._inventoryService
      .showByContainer(
        this.data.data.id,
        e !== null ? e.page : 1,
        e !== null ? e.perPage : 10,
        e !== null ? (this.campoBusqueda = e.search) : (this.campoBusqueda = ""),
        this.filtros
      )
      .subscribe(
        (r) => {
          console.log(r);
          if (r.code === 400 && r.msg === "Authorization not valid") {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else if (r.status === "success") {
            this.paginaActual = Number(r.page_actual);
            this.itemsPorPagina = String(r.items_per_page);
            this.totalItems = Number(r.total_items_count);
            this.totalPaginas = Number(r.total_pages);

            if (newfilter) {

              this.filtros = [
                null,
                { key: 'filter_id', title: 'Id', value: '', type: 'contains', key_type: 'filter_id_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'filter_mfgr', title: 'Mfgr', value: '', type: 'contains', key_type: 'filter_mfgr_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'filter_item', title: 'Item', value: '', type: 'contains', key_type: 'filter_item_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'filter_serial', title: 'Serial', value: '', type: 'equalto', key_type: 'filter_serial_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'filter_condition', title: 'Condition', value: '', type: 'startswith', key_type: 'filter_condition_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'contains', name: 'Contains' }, { value: 'startswith', name: 'Starts With' }, { value: 'endswith', name: 'Ends With' }, { value: 'equalto', name: 'Equal To' }
                ] },
                { key: 'filter_status', title: 'Status', value: '', type: 'equalto', key_type: 'filter_status_type', type_options: [
                  { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }
                ] },
                null
              ];
            }

            if(this.totalItems > 0){
              this.options.find(option => option.colName === 'View Items').visibility = true;
              this.ref.detectChanges();
            } else if (additems) {
              this.options.find(option => option.colName === 'View Items').visibility = false;
              this.ref.detectChanges();
            } else if (this.totalItems === 0 && !newfilter){
              this.options.find(option => option.colName === 'View Items').visibility = true;
              this.ref.detectChanges();
            } else if (this.totalItems === 0 && newfilter){
              this.options.find(option => option.colName === 'View Items').visibility = false;
              this.tab = 1;
              this.ref.detectChanges();
            }

            let actionButtons;

            if (this.enableAsVirtual) {
              actionButtons = [
                { icon: "remove_red_eye", action: "Detail", color: "info" },
                { icon: "logout", action: "Remove", color: "danger" },
                //{ icon: 'trending_up', action: 'Change', color: 'success'}
              ];
            } else {
              actionButtons = [
                { icon: "remove_red_eye", action: "Detail", color: "info" },
                { icon: "logout", action: "Remove", color: "danger" },
              ];
            }

            this.inventories.rows = [];
            for (const element of r.data) {

              let selected_value = false;

              if(
                  this.bulk.includes(element.id.toString())
                )
                  selected_value = true;

              this.massiveBulk.push(element.id);

              this.inventories.rows.push([
                new Cell(element.id, {type: 'checkbox', selected: selected_value}), // Check box
                new Cell(element.id),
                new Cell(element.mfgr),
                new Cell(element.item),
                new Cell(element.serialnumber),
                new Cell(element.conditioninventory),
                new Cell(element.status, {
                  class: "fw-bold",
                  color: element.status === "Available" ? "green" : "orange",
                }),
                new Cell(actionButtons, { type: "actions" }),
              ]);
            }
          } else {
            this.mtds.notifyError(r.msg, r.code);
          }
          this.loadingInventories = false;
        },
        (error) => {
          this.loadingInventories = false;
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
  }

  public vaciar_id;

  vaciarContainer(id){

    this.vaciar_id = id;

    if(this.bulk.length === 0)
      //this.dropContainer(id);
      $("#removeItemsModal").modal("show");
    else{

      $("#removeItemsModal").modal("show");

      /*swal.fire({
        title:
          `Are you sure you want to remove this item from this container ${this.item.id}?`,
        showCancelButton: true,
        buttonsStyling: false,
        customClass:{
          cancelButton: 'order-1 btn btn-danger',
          confirmButton: 'order-2 btn btn-success',
        },
        confirmButtonColor: "#4CAF50",
        confirmButtonText: "Yes, Remove",
        icon: "info",
        iconColor: '#C19A0A'
      }).then(
        function (result) {
          if (result.value) {
            this.removeItemsContainer();
          }
        }.bind(this)
      );*/
    }
  }

  removeItemsContainerModal() {

    $("#removeItemsModal").modal("hide");

    if(this.bulk.length > 0)
      this.removeItemsContainer();
    else
      this.dropContainer(this.vaciar_id);
  }

  ModalRemoveItemsContainer() {
    ($("#modalRemoveItems") as any).modal("show");
  }

  removeItemsContainer() {
    //($("#modalRemoveItems") as any).modal("hide");

    let json = {
      bulk: this.bulk,
    };

    this.savingItem = true;
    swal.fire({
          
      title: "We are removing items from this container. This process may take some time. Please check back in about 2-3 Mins.",
      text: "",
      buttonsStyling: false,
   
      customClass:{
        confirmButton: 'btn btn-success'
      },
      icon: "success",
    });
    
    this._ticketsService.removeBulkItemContainer(this.item.id, json).subscribe(
      (r) => {
        console.log(r);
        if (r.code === 200) {
          /*swal.fire({
          
            title: "Item(s) has been removed successfully",
            text: "",
            buttonsStyling: false,
         
            customClass:{
              confirmButton: 'btn btn-success'
            },
            icon: "success",
          });*/
          //this.mtds.notifySuccess("Item(s) has been removed successfully");

          this.bulk = [];
          this.getInventories();
        } else {
          this.mtds.notifyError(r.msg);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  removeItemFromArray(id) {

    this.itemsID = this.itemsID.filter((item) => item.id_inventory !== id);
    //this.checkItemsNotFound();

    // Dividir la cadena en un array utilizando el salto de línea como separador
    let idsArray = this.nuevo.value.split(/\s+/);

    // Encontrar el índice del ID a eliminar
    let indexToRemove = idsArray.indexOf(id);

    // Si se encuentra el ID a eliminar, eliminarlo del array
    if (indexToRemove !== -1) {
        idsArray.splice(indexToRemove, 1);
    }

    // Unir los elementos del array de nuevo en una cadena
    this.nuevo.value = idsArray.join('\n');
  }

  removeItemFromArrayAdd(id) {
    this.itemsAdd = this.itemsAdd.filter((item) => item.id_inventory !== id);
  }

  checkItemsNotFound() {
    let arrayNotFound = this.itemsID.filter(
      (item) => item.status === 0 || (item.status !== 0 && item.status !== 1)
    );

    if (arrayNotFound.length > 0) this.confirmMove = false;
    else this.confirmMove = true;
  }

  confirmChangeContainer() {

    this.saveConfirmMove = true;

    let json = {
      containerID: this.item.id,
      itemsID: this.itemsID,
      type: this.nuevo.type,
    };

    this._ticketsService.changeContainer(json).subscribe(
      (r) => {
        console.log(r);
        if (r.code === 200) {
          swal.fire({
          
            title: "Containers have been moved successfully",
            text: "",
            buttonsStyling: false,
           customClass:{
    confirmButton: 'btn btn-success'
            },
          });

          $("#createModal").modal("hide");
          this.cleanValues();
          this.getInventories();
          this.saveConfirmMove = false;
        } else {
          this.saveConfirmMove = false;
          this.mtds.notifyError(r.msg);
        }
      },
      (error) => {
        this.saveConfirmMove = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  saveChangeContainer() {
    swal.fire({
      title: "Move virtual container",
      text:
        "Are you sure to move to this container " +
        this.containerinventory +
        "?",
      showCancelButton: true,
      buttonsStyling: false,
 
      customClass:{
        cancelButton: 'order-1 btn btn-danger',
        confirmButton: 'order-2 btn btn-success',
      },
      confirmButtonColor: "#4CAF50",
      confirmButtonText: "Yes, move it",
      icon: "info",
      iconColor: '#C19A0A'
    }).then(
      function (result) {
        if (result.value) {
          let json = {
            virtualID: this.virtualContainerID,
            itemID: this.itemID,
          };

          this._ticketsService.changeVirtualContainer(json).subscribe(
            (r) => {
              console.log(r);
              if (r.code === 200) {
                swal.fire({
            
                  title: "Container has been moved successfully",
                  text: "",
                  buttonsStyling: false,
                 
                  customClass:{
                    confirmButton: 'btn btn-success'
                  },
                  icon: "success",
                });

                this.showContainerList = false;
                $("#changeVirtualContainer").modal("hide");
                this.getInventories();
              } else {
                this.mtds.notifyError(r.msg);
              }
            },
            (error) => {
              this.mtds.notifyError(error.statusText, error.status);
            }
          );
        }
      }.bind(this)
    );
  }

  dropContainer(id) {
    /*swal.fire({
      title: "Are you sure you want to empty this container?",
      showCancelButton: true,
      buttonsStyling: false,
    
      customClass:{
        cancelButton: 'order-1 btn btn-danger',
        confirmButton: 'order-2 btn btn-success',
      },
      confirmButtonColor: "#4CAF50",
      confirmButtonText: "Yes, empty it",
      icon: "info",
      iconColor: '#C19A0A'
    }).then(
      function (result) {
        if (result.value) {
          this._ticketsService.dropContainer(id).subscribe(
            (r) => {
              console.log(r);
              if (r.code === 200) {
                swal.fire({
              
                  title: "Container has been empty successfully",
                  text: "",
                  buttonsStyling: false,
                
                  customClass:{
                    confirmButton: 'btn btn-success'
                  },
                  icon: "success",
                });

                this.getInventories();
              } else {
                this.mtds.notifyError(r.msg);
              }
            },
            (error) => {
              this.mtds.notifyError(error.statusText, error.status);
            }
          );
        }
      }.bind(this)
    );*/

    swal.fire({
          
      title: "We are removing items from this container. This process may take some time. Please check back in about 2-3 Mins.",
      text: "",
      buttonsStyling: false,
   
      customClass:{
        confirmButton: 'btn btn-success'
      },
      icon: "success",
    });

    this._ticketsService.dropContainer(id).subscribe(
      (r) => {
        console.log(r);
        if (r.code === 200) {
          this.mtds.notifySuccess("Container has been empty successfully");

          this.getInventories();
        } else {
          this.mtds.notifyError(r.msg);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  changecontainer(event) {
    this.containerinventory = event.name;
    this.virtualContainerID = event.id;
  }

  actions(e) {
    switch (e.action) {
      case "Detail":
        window.open(`/inventory/product/${e.id}`);
        break;

      case "Remove":
        swal.fire({
          title:
            `Are you sure you want to remove this item from this container ${this.item.id}?`,
          showCancelButton: true,
          buttonsStyling: false,
          customClass:{
            cancelButton: 'order-1 btn btn-danger',
            confirmButton: 'order-2 btn btn-success',
          },
          confirmButtonColor: "#4CAF50",
          confirmButtonText: "Yes, Remove",
          icon: "info",
          iconColor: '#C19A0A'
        }).then(
          function (result) {
            if (result.value) {
              let json = {
                container_id: this.item.id,
              };

              this._ticketsService.removeItemContainer(e.id, json).subscribe(
                (r) => {
                  console.log(r);
                  if (r.code === 200) {
                    swal.fire({
                 
                      title: "Item(s) has been removed successfully",
                      text: "",
                      buttonsStyling: false,
                   
                      customClass:{
                        confirmButton: 'btn btn-success'
                      },
                      icon: "success",
                    });

                    this.removeItemFromArrayAdd(e.id);

                    this.getInventories();
                  } else {
                    this.mtds.notifyError(r.msg);
                  }
                },
                (error) => {
                  this.mtds.notifyError(error.statusText, error.status);
                }
              );
            }
          }.bind(this)
        );

        break;

      case "Change":
        this.itemID = e.id;
        this.showContainerList = true;
        $("#changeVirtualContainer").modal("show");
        break;
    }
  }

  sumarPeso() {

    if(this.data.poNumber != undefined){
      const match = this.poOptions.find(option => option.po === this.data.poNumber);

      if (match) {
          //console.log("warehouseId:", match.warehouseId);
          this.whs_id = match.warehouseId;
      } else {
          //console.log("No se encontró el PO");
      }
    }

    let restar = 0;
    let me = this;
    console.log(this.containers);
    const filtered = this.containers.filter(function (element) {
      return element.name === me.item.item;
    });    

    if (filtered.length > 0) restar = filtered[0].tare;

    if(this.item.weight !== null && filtered.length > 0){

      switch (this.item.item) {
        case "Box":
          this.item.totalNetWeight = Number(this.item.weight) - Number(restar);
          break;
        case "Gondola":
          this.item.totalNetWeight = Number(this.item.weight) - Number(restar);
          break;
        case "Gaylord":
          this.item.totalNetWeight = Number(this.item.weight) - Number(restar);
          break;
        case "Pallet":
          this.item.totalNetWeight = Number(this.item.weight) - Number(restar);
          break;
        case "H-Dolly":
          this.item.totalNetWeight = Number(this.item.weight) - Number(restar);
          break;
        case "HDolly":
          this.item.totalNetWeight = Number(this.item.weight) - Number(restar);
          break;
        case "Rack":
          this.item.totalNetWeight = Number(this.item.weight) - Number(restar);
          break;
        case "Standalone":
          this.item.totalNetWeight = Number(this.item.weight) - Number(restar);
          break;
        default:
          this.item.totalNetWeight = Number(this.item.weight) - Number(restar);
      }

      this.getLocations();

    }

  }

  getLocations() {
    this.locationsList = [];

    if (
      (this.whs_id != null &&
        this.whs_id > 0 &&
        this.item.item !== "" &&
        this.item.item !== null) ||
      this.item.weight < 0
    ) {
      
      this.loadingLocations = true;

      let json = {
        item: this.item.item,
        totalNetWeight: this.item.weight,
        po: this.po,
        showAllLocations: this.showAllLocations,
        ...(this.is_warehouse && { whs: this.whs_id })
      };

      this._locationService
        .getAvailables(this.token, this.whs_id, json)
        .subscribe(
          (response) => {
            this.loadingLocations = false;
            console.log(response);
            if (response.status === "success") {
              this.locationsList = response.data.map((item) => {
                return {
                  id: item.id,
                  name: `${item.location.name} - ${item.locationName}: ${item.locationRow}-${item.locationBay}-${item.locationLevel}-${item.locationSection}`,
                  linkTo: item.linkTo,
                };
              });

              const flat = this.locationsList.find(
                (item) => item.id === this.item.internallocation_id
              );

              if (!flat && this.item.internallocation_id !== null) {
                const location = {
                  id: this.item.internallocation_id,
                  name: this.item.nameInternal,
                  linkTo: this.item.linkTo,
                };
                this.locationsList.push(location);
              }
            }
            this.loading = false;
          },
          (error) => {
            this.loadingLocations = false;
            console.log(<any>error);
            // this.showSwal('error');
          }
        );
    }
  }

  selectPO(event) {
    console.log("selectPO event => ", event);
    this.item.po_id = event.id;
    this.po = event.name;
    this.whs_id = event.warehouseId;

    this._processingpService.getstage(this.token, event.name).subscribe(
      (r) => {
        console.log(r);
        this.item.is_pi = r.data;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  addPhoto(){
    const dialog = this.dialog.open(ContainerphotosComponent, {
        width: "60%",
        data: {
          container_id: this.item.id,
          type: this.item.item,
          po: this.item.po_id,
        },
      });

      dialog.afterClosed().subscribe((result) => {
        
      });
  }

  save() {
    this.saving = true;
    if (this.item.id === null) {
      if (this.enableAsVirtual) {
        console.log(this.item);

        this.item.enableAsAVirtualContainer = 1;

        this._ticketsService.createVirtual(this.item).subscribe(
          (r) => {
            if (r.status === "success") {
              this.item.id = r.data.id;
              this.virtualContainerID = this.item.id;
              this.unlockNameVirtual = false;
              this.refreshVirtualCreationTabs();
              this.tab = 1;
              this.ref.detectChanges();
            } else {
              this.mtds.notifyError(r.msg, r.code);
            }
            this.saving = false;
          },
          (error) => {
            this.mtds.notifyError(error.statusText, error.status);
            this.saving = false;
          }
        );
      } else {
        this._ticketsService
          .createWeight(this.item, this.bulk_cant || 0)
          .subscribe(
            (r) => {
              if (r.status === "success") {
                this.dialogRef.close(r);
              } else {
                this.mtds.notifyError(r.msg, r.code);
              }
              this.saving = false;
            },
            (error) => {
              this.mtds.notifyError(error.statusText, error.status);
              this.saving = false;
            }
          );
      }
    } else {
      this.editWeight();
      const json = {
        data: [
          {
            idweight: this.item.id,
            idlocation: this.item.internallocation_id,
            po_id: this.item.po_id,
            item: this.item.item,
            weight: this.item.weight,
            totalNetWeight: this.item.totalNetWeight,
            damages: this.item.damages,
            comments: this.item.comments,
            internallocation_id: this.item.internallocation_id,
            is_pi: this.item.is_pi,
            typeEquipment: this.item.typeEquipment,
            customType: this.item.typeEquipment === 'Custom' ? this.item.customType : null,
          },
        ],
      };

      this._ticketsService.bulkLocations(json).subscribe(
        (r) => {
          console.log(r);
          if (r.status === "queued" && r.jobId) {
            // changebulklocation now runs as a background job — wait for it to
            // finish (see onBulkLocationJobDone) instead of assuming success here.
            this.activeBulkLocationJobId = r.jobId;
          } else {
            this.mtds.notifyError(r.msg, r.code);
            this.saving = false;
          }
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.saving = false;
        }
      );
    }
  }

  public activeBulkLocationJobId: string | null = null;

  onBulkLocationJobDone(job: any) {
    this.activeBulkLocationJobId = null;
    this.saving = false;

    if (job.status === "done") {
      // this.mtds.notifySuccess('The location was changed successfully');
      //  this.dialogRef.close('ok');
    } else {
      this.mtds.notifyError(job.msg || "Something went wrong processing this batch.");
    }
  }

  close() {
    this.dialogRef.close();
  }

  // Only the PO page passes isMobile; every other caller keeps the desktop layout
  get isMobile(): boolean {
    return !!this.data?.isMobile;
  }

  getChat() {
    // console.log(this.item.id);
    this.jsonChatLog = {
      type: "CONTAINERINVENTORY",
    };
    this._chatLogService
      .getChat(this.token, this.item.id, this.jsonChatLog)
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.chats = response.data;
            this.total_chats = this.chats.length;
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  sendMessage(message: string) {
    message = message.trim();
    if (message.length > 0) {
      this.newchatmsg = message;

      if (this.item.id === null) {
        this.getItemId();
      } else {
        this.sendChat();
      }
    }
  }

  getItemId() {
    this.saving = true;
    this._ticketsService.createWeight(this.item).subscribe(
      (r) => {
        console.log(r);
        if (r.status === "success") {
          this.item.id = r.data.id;
          this.sendChat();
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.saving = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.saving = false;
      }
    );
  }

  deleteChat(id) {
    this.idChat = id;

    if (confirm("Are you sure you want to delete this chat?")) {
      this.saving = true;
      this._chatLogService.remove(this.token, this.idChat).subscribe(
        (response) => {
          if (response.status != "success") {
            if (response.longmsg) {
              this.showSwal("error", response.msg, response.longmsg);
            } else {
              this.showSwal("error", "ERROR!", response.msg);
            }
          } else {
            this.showSwal(
              "success",
              "Chat removed!",
              "The chat has been removed successfully"
            );
            this.getChat();
          }
          this.saving = false;
        },
        (error) => {
          console.log(<any>error);
          this.saving = false;
          this.showSwal("error");
        }
      );
    }
  }

  sendChat() {
    this.loading2 = true;

    let enviar;
    enviar = {
      message: this.newchatmsg,
      father_id: this.item.id,
      type: "CONTAINERINVENTORY",
    };

    console.log(enviar);

    this._chatLogService.create(this.token, enviar).subscribe(
      (response) => {
        this.loading2 = false;
        if (response.status === "success") {
          console.log(response.data);

          this.chats.push(response.data);

          this.myWebSocket.next({
            notify: "1",
            data: this.item.id,
            type: "CONTAINER-NOTE-ADDED",
            token: this.token,
            action: "NEW", // NEW ó UPDATE ó DELETE
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );

          this.myWebSocket.next({
            notify: "1",
            data: this.item.id,
            type: "CONTAINERTAGGED",
            token: this.token,
            action: "NEW", // NEW ó UPDATE ó DELETE
            toDestiny: "USERS",
            toData: this.newchatmsg,
            element: this.item.id,
            texto: this.item.id,
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );

          this.newchatmsg = "";
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  editWeight() {
    this.saving2 = true;
    if (this.item.id !== null) {
      console.log("Entra");
      const json = {
        data: [
          {
            idweight: this.item.id,
            idlocation: this.whs_id,
            po_id: this.item.po_id,
            item: this.item.item,
            weight: this.item.weight,
            totalNetWeight: this.item.totalNetWeight,
            damages: this.item.damages,
            comments: this.item.comments,
            internallocation_id: this.item.internallocation_id,
            is_pi: this.item.is_pi,
            typeEquipment: this.item.typeEquipment,
            customType: this.item.typeEquipment === 'Custom' ? this.item.customType : null,
          },
        ],
      };

      this._ticketsService.editWeight(json).subscribe(
        (r) => {
          console.log(r);
          if (r.code === 200) {
            this.mtds.notifySuccess("Changes have been made successfully");
            this.dialogRef.close(r);
          } else {
            this.mtds.notifyError(r.msg, r.code);
          }
          this.saving = false;
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
    }
  }

  public idToMove: string = '';
  public moving: boolean = false;
  public moveMode: 'all' | 'selected' = 'all';

  moveItemsModal(){
    this.moveMode = 'all';
    $("#moveItemsModal").modal("show");
  }

  moveItems(){

    this.moving = true;

    let json: any = {
      id_container: this.idToMove
    };

    if (this.moveMode === 'selected' && this.bulk.length > 0) {
      json.item_ids = this.bulk;
    }

    this._serviceWeigth.changeBulkItems(this.token, json, this.item.id).subscribe(
        (r) => {
        console.log(r);
        if (r.code === 200) {
          this.mtds.notifySuccess("Items have been moved successfully");
          $("#moveItemsModal").modal("hide");
          this.getInventories();
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.moving = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );

  }

  public showAllLocations: boolean = false;

  onCheckboxChange(event) {
    if(event.checked)
      this.showAllLocations = true;
    else
      this.showAllLocations = false;

    //this.getLocationsNewContainer();
    this.getLocations();
  }


  showSwal(type, title = "", message = "") {
    if (type === "success") {
      swal.fire({
   
        title: title,
        text: message,
        buttonsStyling: false,
         customClass:{
    confirmButton: 'btn btn-success'
            },

      });
    } else if (type === "error") {
      swal.fire({
     
        title: title,
        text: message,
        buttonsStyling: false,
        customClass:{
    confirmButton: 'btn btn-success'
            },
      });
    }
  }
}
